<!-- Adapted from Koel ui/ScreenHeader.vue, 40183ac (MIT).
     Thumbnail + name/meta + controls slots and collapsed/expanded layout retained; Tailwind translated to scoped CSS. -->
<template>
  <header class="screen-header" :class="[layout, { disabled, compact }]" data-upstream-component="Koel/ScreenHeader">
    <aside v-if="$slots.thumbnail && layout === 'expanded'" class="thumbnail-wrapper"><slot name="thumbnail" /></aside>
    <div class="header-main">
      <div class="heading-copy"><h1 class="name"><slot /></h1><div v-if="$slots.meta" class="meta"><slot name="meta" /></div></div>
      <slot name="controls" />
    </div>
  </header>
</template>
<script>
export default { name: 'KoelScreenHeader', props: { layout: { type: String, default: 'collapsed' }, disabled: Boolean, compact: Boolean } };
</script>
<style scoped>
.screen-header { display:flex; gap:16px; align-items:flex-end; min-width:0; min-height:56px; padding:0 0 8px; }
.header-main { display:flex; flex:1; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; min-width:0; }
.heading-copy { display:flex; align-items:baseline; flex-wrap:wrap; flex:1; gap:8px; min-width:100px; }
h1.name { margin:0; font-size:24px; font-weight:500; line-height:1.35; overflow-wrap:anywhere; }
.meta { display:flex; flex-wrap:wrap; gap:8px; font-size:14px; line-height:1.5; color:var(--salt-subtext,var(--color-secondary)); }
.thumbnail-wrapper { flex: 0 0 92px; width: 92px; height: 92px; overflow: hidden; border-radius: 6px; }
.expanded .header-main { flex-direction: column; align-items: stretch; }
.collapsed { gap: 0; }
.disabled { opacity: .5; pointer-events: none; }
.compact .thumbnail-wrapper { display: none; }
.compact h1.name { font-size: 24px; }
</style>
